module.exports = __webpack_public_path__ + "img/zxsign3.dde845d4.png";